import React from 'react';

export default function useDiv() {
  const domNode = React.useMemo(() => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    return div;
  }, []);
  React.useEffect(() => {
    return function cleanup() {
      document.body.removeChild(domNode);
    };
  }, [domNode]);
  return domNode;
}
